var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "video_channel" }, [
        _c(
          "div",
          { staticClass: "vc_concent" },
          _vm._l(_vm.channelList, function (item) {
            return _c("div", { key: item.at_id, staticClass: "vc_item" }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      item.at_name == "推荐"
                        ? "/marvel-list?id=" + item.at_id
                        : "/list-page?id=" + item.at_id,
                    target: "_blank",
                  },
                },
                [_vm._v(" " + _vm._s(item.at_name) + " ")]
              ),
            ])
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "video_details" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.playerOptions.sources[0].src,
                expression: "playerOptions.sources[0].src",
              },
            ],
            staticClass: "v_player",
          },
          [
            _c("video-player", {
              ref: "videoPlayer",
              staticClass: "video-player vjs-custom-skin",
              attrs: { playsinline: true, options: _vm.playerOptions },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isAlbumDisplay,
                expression: "isAlbumDisplay",
              },
            ],
            staticClass: "video_album",
          },
          [
            _c("div", { staticClass: "album_bar" }, [
              _c("span", { staticClass: "album_item" }, [_vm._v("选集")]),
              _c(
                "span",
                { staticClass: "cancel", on: { click: _vm.disPlayAlbum } },
                [_vm._v("取消")]
              ),
            ]),
            _c(
              "ul",
              { staticClass: "album_num" },
              _vm._l(_vm.albumList, function (item) {
                return _c(
                  "li",
                  {
                    key: item.column,
                    class: item.column == _vm.currentNum ? "active" : "",
                    on: {
                      click: function ($event) {
                        return _vm.changeAlum(item.column)
                      },
                    },
                  },
                  [
                    _c("p", { staticClass: "item_idx" }, [
                      _vm._v(_vm._s(item.column)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _c("div", { staticClass: "vd_right" }, [
          _c("div", { staticClass: "vd_title" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
          ]),
          _c("div", { staticClass: "vd_text" }, [
            _vm._v(_vm._s(_vm.description)),
          ]),
          _c("div", { staticClass: "vd_copyright" }, [
            _vm._v("版权归原作者所有，如有侵权，请联系我们"),
          ]),
          _vm._m(0),
        ]),
      ]),
      _c("download-dialog", {
        attrs: { visible: _vm.dialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "share_info" }, [
      _c("div", { staticClass: "share_sub" }, [_vm._v("分享到：")]),
      _c("div", {
        staticClass: "social-share",
        attrs: { "data-sites": "wechat, weibo, qq, qzone, douban" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }